module.exports = __webpack_public_path__ + "img/logo_planification_en.668d0d56.png";